import { gql } from '@apollo/client'

export const SABRE_DELETE_CATEGORY = gql`
  mutation DeleteCategory($input: DeleteCategoryInput!) {
    deleteCategory(input: $input) {
      deleted
    }
  }
`
